import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  MenuItem,
  Select,
  Typography
} from '@material-ui/core';
import PropTypes from 'prop-types';
import './RenewalsOptionsPanel.css';
import { injectIntl } from 'react-intl';

const renewalTermOptions = (props) => [
  {
    value: 1,
    label: props.intl.formatMessage({
      id: '1_year'
    }),
    color: { color: 'red' }
  },
  {
    value: 2,
    label: props.intl.formatMessage({
      id: '2_years'
    }),
    color: { color: 'red' }
  },
  {
    value: 3,
    label: props.intl.formatMessage({
      id: '3_years'
    })
  },
  {
    value: 4,
    label: props.intl.formatMessage({
      id: '4_years'
    })
  },
  {
    value: 5,
    label: props.intl.formatMessage({
      id: '5_years'
    })
  }
];

const RenewalsOptionsPanel = (props) => {
  return (
    <Accordion className="expansion-panel" defaultExpanded>
      <AccordionSummary>
        <Typography className="customer-options">
          {props.intl.formatMessage({
            id: 'options'
          })}{' '}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="renewals-options-panel-expansion-details">
        <div className="options-panel">
          <form className="renewal-options-form">
            <Typography className="options-header">
              {' '}
              {props.intl.formatMessage({
                id: 'renewal_term'
              })}
            </Typography>
            <FormControl className="renewal-term expand-field-width">
              <Select
                value={props.selectedTerm}
                onChange={(event) => props.handleChangeTerm(event.target.value)}
                inputProps={{
                  name: 'term-value',
                  id: 'term-value-select'
                }}
                disabled={props.disabled}
                style={
                  props.selectedTerm === 1 || props.selectedTerm === 2
                    ? { color: 'red' }
                    : null
                }
              >
                {renewalTermOptions(props).map((option, index) => (
                  <MenuItem
                    key={index}
                    value={option.value}
                    style={option.color}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </form>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

RenewalsOptionsPanel.propTypes = {
  handleChangeTerm: PropTypes.func,
  selectedTerm: PropTypes.number.isRequired,
  disabled: PropTypes.bool
};

export default injectIntl(RenewalsOptionsPanel);
